import { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppLayout from '@cloudscape-design/components/app-layout';
import SideNavigation from '@cloudscape-design/components/side-navigation';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import type { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { useAuth } from '../hooks/useAuth';

const BASE_NAV_ITEMS: SideNavigationProps.Item[] = [
  { type: 'link', text: 'Search', href: '/' },
  { type: 'link', text: 'Governance', href: '/governance' },
  { type: 'link', text: 'Author', href: '/author' },
];

const ADMIN_NAV_ITEM: SideNavigationProps.Item = { type: 'link', text: 'Sources', href: '/sources' };

function buildNavItems(isSourceAdmin: boolean): SideNavigationProps.Item[] {
  return isSourceAdmin ? [...BASE_NAV_ITEMS, { type: 'divider' }, ADMIN_NAV_ITEM] : BASE_NAV_ITEMS;
}

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isSourceAdmin = user?.role === 'knowledge-source-admin' || user?.role === 'platform-admin';
  const navItems = buildNavItems(isSourceAdmin);

  return (
    <>
      <div style={{ position: 'sticky', top: 0, zIndex: 1002 }}>
        <TopNavigation
          identity={{ href: '/', title: 'Manamind KB' }}
          utilities={[
            {
              type: 'menu-dropdown',
              text: user?.email || '',
              description: (user?.role || 'viewer').toUpperCase(),
              iconName: 'user-profile',
              onItemClick: ({ detail }) => {
                if (detail.id === 'signout') logout();
              },
              items: [{ id: 'signout', text: 'Sign out' }],
            },
          ]}
        />
      </div>
      <AppLayout
        navigation={
          <SideNavigation
            activeHref={location.pathname}
            items={navItems}
            onFollow={(e) => {
              e.preventDefault();
              if (e.detail.href !== '#') {
                navigate(e.detail.href);
              }
            }}
          />
        }
        toolsHide
        content={children}
      />
    </>
  );
}
